/**
 * Panel geometry, in one place. The pane docks at 360px, draggable up to 720px
 * via the left-edge grip, collapsing to a 34px rail while a draft is open;
 * below ~1100px viewports the pane floors at 300px via CSS, not a drag.
 *
 * 360 is the design default (Roslynn, 2026-08-20): it leaves the applicant
 * detail pages usable with the panel open. The report step is the densest view
 * and reads tighter there — its summary gutter collapses and findings wrap
 * harder — so the drag ceiling is the escape hatch, which is why 720 ships with
 * the default rather than after it.
 */
export const PANEL_WIDTH_DEFAULT = 360;
export const PANEL_WIDTH_MIN = 360;
export const PANEL_WIDTH_MAX = 720;
export const PANEL_RAIL_WIDTH = 34;
